var pagerTemplate = require('./pager-template.handlebars');

function Pager() {
    this.pagerId = undefined;
    this.pagerContainerSelector = undefined;
    this.currentPage = undefined;
    this.pageSize = undefined;
    this.totalPages = undefined;
    this.pageChangeCallback = undefined;

    this.getPagerId = () => this.pagerId;
    this.setPagerId = (x) => this.pagerId = x;
    this.getPagerContainerSelector = () => this.pagerContainerSelector;
    this.setPagerContainerSelector = (x) => this.pagerContainerSelector = x;
    this.getCurrentPage = () => this.currentPage;
    this.setCurrentPage = (x) => this.currentPage = x;
    this.getPageSize = () => this.pageSize;
    this.setPageSize = (x) => this.pageSize = x;
    this.getTotalPages = () => this.totalPages;
    this.setTotalPages = (x) => this.totalPages = x;
    this.getPageChangeCallback = () => this.pageChangeCallback;
    this.setPageChangeCallback = (x) => {
        if (typeof x === 'function') {
            this.pageChangeCallback = x;
        }
    };
}

Pager.prototype.create = function (pagerId, pagerContainerSelector, callback, totalPages) {
    let _this = this;

    _this.setPagerId(pagerId);
    _this.setPagerContainerSelector(pagerContainerSelector);
    _this.setTotalPages(totalPages);
    _this.setPageChangeCallback(callback);

    //Generate Pager HTML and insert into pagerContainer
    var html = pagerTemplate({ pagerData: _this });
    $(`${_this.getPagerContainerSelector()}`).html(html);

    initializePagerEvents(_this);
}

Pager.prototype.update = function (pagerId, pagerContainerSelector, callback, totalPages, currentPage) {
    let _this = this;

    _this.setCurrentPage(currentPage);

    if (!$(`#${pagerId}`).length || totalPages !== _this.getTotalPages()) {
        _this.create(pagerId, pagerContainerSelector, callback, totalPages);
    }

    //Show/Hide Entire Pager
    (_this.getTotalPages() === 1)
        ? $(`#${_this.getPagerId()}`).addClass('hidden')
        : $(`#${_this.getPagerId()}`).removeClass('hidden');

    //Hide all pages
    $(`#${_this.getPagerId()} a`)
        .parent()
        .addClass('hide');

    //Show pages 2 less than current page and pages 2 more than current page. (NOTE: CurrentPage is index value, not display value)
    $(`#${_this.getPagerId()} a`)
        .filter(function () {
            return $(this).data('page') < (_this.getCurrentPage() + 3) && $(this).data('page') > (_this.getCurrentPage() - 3);
        })
        .parent()
        .removeClass('hide');

    //Remove all active page
    $(`#${_this.getPagerId()} a`).removeClass('active');

    //make current page active
    $(`#${_this.getPagerId()} a[data-page=${_this.getCurrentPage()}]`).addClass('active');

    //Handle next page button
    (_this.getCurrentPage() + 1 < _this.getTotalPages())
        ? $(`#${_this.getPagerId()} #${_this.getPagerId()}-next`).prop("disabled", false)
        : $(`#${_this.getPagerId()} #${_this.getPagerId()}-next`).prop("disabled", true);

    //Handle previous page button
    (_this.getCurrentPage() > 0)
        ? $(`#${_this.getPagerId()} #${_this.getPagerId()}-previous`).prop("disabled", false)
        : $(`#${_this.getPagerId()} #${_this.getPagerId()}-previous`).prop("disabled", true);
}

function initializePagerEvents(thisPager) {

    $(`#${thisPager.pagerId} button#${thisPager.pagerId}-previous`).on('click', function () {
        let page = thisPager.getCurrentPage();

        if (page > 0) {
            page--;
            thisPager.setCurrentPage(page)
        } else {
            thisPager.setCurrentPage(0);
        }

        thisPager.pageChangeCallback();
    });

    $(`#${thisPager.pagerId} button#${thisPager.pagerId}-next`).on('click', function () {
        let page = thisPager.getCurrentPage();

        if (page < thisPager.getTotalPages()) {
            page++;
            thisPager.setCurrentPage(page)
        } else {
            thisPager.setCurrentPage(thisPager.getTotalPages() - 1);
        }

        thisPager.pageChangeCallback();
    });

    $(`#${thisPager.pagerId} a`).on('click', function () {
        thisPager.setCurrentPage($(this).data('page'));

        thisPager.pageChangeCallback();
    });
}

module.exports = Pager;


// WEBPACK FOOTER //
// ./shared/components/pager/pagerService.js